import React from 'react';
import DataList from 'components/molecules/DataList';
import {
  Box,
  Typography,
  Badge,
  Paper,
  ListItemAvatar,
  ListItemIcon,
  Checkbox,
  ListItemText,
  ListItem,
} from '@material-ui/core';
import useStyles from './styles';
import ImageIcon from '@material-ui/icons/Image';
import { Environment } from 'config';
import * as ChatServices from 'services/api/chat';
import { formatDate, timeSince } from 'utils/dates';
import {
  useChats,
  useChatData,
} from 'providers/SocketioProvider/chat/selectors';
import IconButton from '@material-ui/core/IconButton';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import MemberAvatar from '../MemberAvatar';
import { TranslatedTextV2 } from 'components/atoms/TranslatedText';
import { TranslationKey } from '../../configuration';

interface IContactsProps {
  onContactSelected?: (chatId: string) => void;
  selectedChatgroup: string | null;
  selectedUserId?: string;
  selectedProductId?: number;
}

const Chatgroups = ({
  onContactSelected,
  selectedChatgroup,
  selectedUserId,
  selectedProductId,
}: IContactsProps) => {
  const chats = useChats({
    userId: selectedUserId,
    pageSize: 10,
    productId: selectedProductId,
  });
  // console.log('Render??????-----');

  // React.useEffect(() => {
  //   if (
  //     (chats?.items?.length ?? 0) > 0 &&
  //     onContactSelected &&
  //     selectedChatgroup === null
  //   ) {
  //     const id = chats?.items?.[0].guid;
  //     id && onContactSelected(id);
  //   }
  // }, [chats, onContactSelected, selectedChatgroup]);

  return (
    <Paper style={{ width: '100%' }} square variant="outlined">
      <Typography
        style={{ fontSize: '2em', margin: '0.7rem', fontWeight: 800 }}
        variant="h5"
        color="inherit"
      >
        <TranslatedTextV2
          defaultText="Conversations"
          translationKey={`${TranslationKey}.conversations`}
        />
      </Typography>
      <div
        className="chat-scrollbar"
        style={{ overflow: 'auto', maxHeight: '100%' }}
      >
        <DataList
          data={chats?.items ?? []}
          renderElement={(data, index) => {
            return (
              <ContactElement
                {...data}
                selected={data.guid === selectedChatgroup}
                onClick={() =>
                  onContactSelected && onContactSelected(data.guid)
                }
              />
            );
          }}
          overrideParent
          // itemContainerProps={(el, index) => ({
          //   // button: true,
          //   selected: el.guid === selectedChatgroup,
          //   role: undefined,
          // })}
          onElementClick={(el) => {
            // onContactSelected && onContactSelected(el.guid);
          }}
        />
      </div>
    </Paper>
  );
};

type IConectElementProps = ChatServices.IChatsData['items'][0] & {
  selected: boolean;
  onClick: () => void;
};

const ContactElement = (props: IConectElementProps) => {
  const classes = useStyles();
  const chatData = useChatData(props.guid, props);
  const [hover, setHover] = React.useState(false);

  return (
    <ListItem
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      selected={props.selected}
      onClick={props.onClick}
      button
    >
      <ListItemAvatar>
        <MemberAvatar
          src={
            chatData.virtualpath
              ? `${Environment.API_BASE_URL}/${chatData.virtualpath}`
              : undefined
          }
          name={chatData.title as string}
          online={(chatData.onlineMembers ?? 0) > 1}
        />
      </ListItemAvatar>
      <ListItemText
        primary={chatData.title}
        secondaryTypographyProps={{
          style: {
            fontWeight: chatData.read ? 'unset' : 'bold',
            color: chatData.read ? 'unset' : 'black',
            overflow: 'hidden',
            // display: 'inline-block',
          },
        }}
        primaryTypographyProps={{
          style: {
            fontWeight: chatData.read ? 600 : 'bold',
            color: chatData.read ? 'unset' : 'black',
            overflow: 'hidden',
          },
        }}
        secondary={
          <span style={{ display: 'flex', flexWrap: 'wrap' }}>
            <span
              style={{
                display: 'flex',
                maxWidth: '50%',
              }}
            >
              <span
                style={{
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {chatData.latestmessage}
              </span>
            </span>

            <span style={{ display: 'flex' }}>
              <span style={{ marginRight: '0.2rem', marginLeft: '0.2rem' }}>
                &#9642;
              </span>
              {timeSince(chatData.lastupdate ?? new Date())}
            </span>
          </span>
        }
      />

      <ListItemSecondaryAction
        // style={{ visibility: hover ? 'visible' : 'hidden' }}
        className={classes.actionIcon}
        // onClick={(ev) => {
        //   ev.preventDefault();
        // }}
      >
        <IconButton edge="end" aria-label="more">
          <MoreHorizIcon />
        </IconButton>
      </ListItemSecondaryAction>
    </ListItem>
  );
};

export default Chatgroups;
